/**
 * The user's default letter sign-off for the current practice, shown in Settings -> Profile. It is
 * added beneath every clinic letter they send from this practice, and can still be changed on any
 * one letter. The handwritten signature it uses is drawn here too.
 */
app.component("signOffSettings", {
	templateUrl: "app/src/js/components/signOff/signOffSettings.html",
	controller: "signOffSettingsController",
});

app.controller("signOffSettingsController", [
	"$scope",
	"$modal",
	"Session",
	"ClinicLettersAPI",
	"SurgeryAgreementAPI",
	"SignOffService",
	"Base64",
	"FileUploader",
	function ($scope, $modal, Session, ClinicLettersAPI, SurgeryAgreementAPI, SignOffService, Base64, FileUploader) {
		const ctrl = this;

		// Only someone who writes clinic letters has a sign-off, and saving it is checked against the
		// same permission. Without it the card is hidden rather than failing on Save.
		ctrl.canWriteLetters = Session.hasPermission("CLINICAL_LETTER_WRITE");

		ctrl.$onInit = function () {
			if (!ctrl.canWriteLetters) {
				return;
			}
			ctrl.practiceName = Session.practice && Session.practice.name;
			ctrl.status = "loading";
			ctrl.html = "";
			ctrl.savedHtml = "";
			ctrl.signatureDataUrl = null;
			ctrl.isDirty = false;
			ctrl.isStarter = false;

			ClinicLettersAPI.getUserSettings().then(
				function (resp) {
					ctrl.savedHtml = Base64.decode(resp.data.sign_off || "");
					ctrl.isStarter = !SignOffService.hasContent(ctrl.savedHtml);
					ctrl.html = ctrl.isStarter ? SignOffService.starterHtml(Session.user) : ctrl.savedHtml;
					ctrl.signatureDataUrl = resp.data.saved_user_signature_image
						? "data:image/png;base64," + resp.data.saved_user_signature_image
						: null;
					ctrl.status = "";
				},
				function (error) {
					console.error("Fetch letter sign-off settings failed", error && error.status);
					ctrl.status = "load-error";
				}
			);
		};

		ctrl.onChange = function (html, edited) {
			ctrl.html = html;
			if (edited) {
				ctrl.isDirty = true;
				ctrl.status = "";
			}
		};

		ctrl.canSave = function () {
			return ctrl.status !== "saving" && ctrl.status !== "loading" && (ctrl.isDirty || ctrl.isStarter);
		};

		ctrl.save = function () {
			ctrl.status = "saving";
			ClinicLettersAPI.updateUserSettings({ sign_off: Base64.encode(ctrl.html) }).then(
				function (resp) {
					// The server tidies the HTML, so show what was actually saved.
					ctrl.savedHtml = Base64.decode(resp.data.sign_off || "");
					ctrl.html = ctrl.savedHtml;
					ctrl.isDirty = false;
					ctrl.isStarter = false;
					ctrl.status = "saved";
				},
				function (error) {
					console.error("Save letter sign-off failed", error && error.status);
					ctrl.status = "save-error";
				}
			);
		};

		ctrl.cancel = function () {
			ctrl.html = ctrl.isStarter ? SignOffService.starterHtml(Session.user) : ctrl.savedHtml;
			ctrl.isDirty = false;
			ctrl.status = "";
		};

		// Drawing the signature reuses the signature modal from the letter screen, which reads
		// everything from the scope it is opened with.
		ctrl.openSignatureModal = function () {
			const modalScope = $scope.$new();
			modalScope.title = ctrl.signatureDataUrl ? "Update Signature" : "Create Signature";
			modalScope.boundingBox = { width: 600, height: 600 };
			modalScope.signatureClinician = ctrl.signatureDataUrl ? { dataUrl: ctrl.signatureDataUrl } : {};
			modalScope.uploadedItem = {};
			modalScope.uploader = new FileUploader({ queueLimit: 1 });
			modalScope.useClinicianSignature = function (accept) {
				const signature = accept();
				if (signature.isEmpty || !signature.dataUrl) {
					return;
				}
				modalScope.isUploading = true;
				SurgeryAgreementAPI.uploadSignature(Session.user.id, SignOffService.dataUrlToBlob(signature.dataUrl)).then(
					function () {
						ctrl.signatureDataUrl = signature.dataUrl;
						modalScope.signatureModal.hide();
					},
					function (error) {
						console.error("Upload signature failed", error && error.status);
						ctrl.status = "signature-error";
						modalScope.signatureModal.hide();
					}
				);
			};
			modalScope.signatureModal = $modal({
				scope: modalScope,
				templateUrl: "app/src/views/templates/modal.preview-sign.tpl.html",
				show: true,
				title: modalScope.title,
				backdrop: "static",
				keyboard: false,
			});
		};
	},
]);
